export default __webpack_public_path__ + "static/media/anmeldenIcon.4602cda0.svg";